const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Galeria do produto: pre-carrega as fotos seguintes depois do load da pagina,
   em prioridade baixa, para o arraste lateral ser instantaneo sem atrasar a 1a foto. */
(function () {
  function prefetchProductGallery() {
    var imgs = document.querySelectorAll('.product__media-list img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('fetchpriority', 'low');
      imgs[i].removeAttribute('loading');
    }
  }

  function schedule() {
    setTimeout(prefetchProductGallery, 400);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
